import { isBlankCustomValue } from './fieldTypes';

// D4 (#972): a custom field marked Required must be filled when someone creates
// or edits a contact or company in the app. Zero and false are values, so a
// required Number accepts 0. A Checkbox always has a state (an untouched one is
// unticked), so a required Checkbox is never refused.
// A Dropdown or Multi-Select whose options list is empty offers nothing to pick, so a Required one
// would block every save forever: it is not enforced (and the import wizard no longer
// creates one).
// Returns { [field.key]: 'Required' } for the fields that fail, in the shape
// CustomFieldRenderer's `errors` prop takes.
export function missingRequiredCustomFields(fields = [], values = {}) {
    const errors = {};
    (fields || []).forEach((field) => {
        if (!field.required || field.field_type === 'checkbox') return;
        if ((field.field_type === 'select' || field.field_type === 'multi_select') && Array.isArray(field.options) && field.options.length === 0) return;
        // The renderer shows the default when nothing was entered, so it counts.
        const value = values?.[field.key] ?? field.default_value;
        if (isBlankCustomValue(value)) errors[field.key] = 'Required';
    });
    return errors;
}
